import React from 'react';
import { Layout } from '../../layout';
import { BlogPost } from '../../blog';

interface BlogPostPageProps {
  post: any;
  pdf: any;
}

export default function BlogPostPage({ post, pdf }: BlogPostPageProps) {
  return (
    <Layout>
      <BlogPost post={post} pdf={pdf} />
    </Layout>
  );
}
